"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimalFeeAmountToCoverFees = void 0;
/**
 * Calculates the minimal additional amount needed to cover transaction fees.
 *
 * @param {Object} params - The parameters for the calculation.
 * @param {number} params.netAmount - The desired net amount to be received.
 * @param {Object} params.fees - The fee structure.
 * @param {number} params.fees.fixed - The fixed fee amount.
 * @param {number} params.fees.relative - The relative fee percentage.
 * @returns {number} The minimal additional amount needed to cover the fees.
 */
const minimalFeeAmountToCoverFees = ({ netAmount, fees, }) => {
    // Calculate the gross amount needed to result in the desired net amount after fees
    const minimalGrossAmountToCoverFees = (netAmount + fees.fixed) / (1 - fees.relative / 100);
    // Return the difference between the gross and net amounts
    return minimalGrossAmountToCoverFees - netAmount;
};
exports.minimalFeeAmountToCoverFees = minimalFeeAmountToCoverFees;
//# sourceMappingURL=minimalFeeAmountToCoverFees.js.map